var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialWaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social_wa_white",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0622,17.1324 C18.4619,18.0252 17.7073,18.6261 16.6611,18.7806 C16.0608,18.7806 15.3062,19.0725 12.322,17.8878 C9.78369,16.686 7.67417,14.7287 6.18207,12.4796 C5.29024,11.4323 4.82717,10.0759 4.68997,8.71958 C4.68997,7.51775 5.13588,6.47044 5.89051,5.71501 C6.18207,5.42313 6.49078,5.26861 6.78234,5.26861 L7.53696,5.26861 C7.82852,5.26861 8.13723,5.26861 8.29159,5.86953 C8.58315,6.62496 9.33777,8.42771 9.33777,8.58223 C9.49213,8.73675 9.42353,9.88707 8.7375,10.5395 C8.36019,10.9687 8.29159,10.9859 8.44594,11.2949 C9.04621,12.1877 9.80084,13.0977 10.5383,13.8531 C11.4301,14.6086 12.3391,15.2095 13.3853,15.6559 C13.6769,15.8104 13.9856,15.8104 14.1399,15.5013 C14.2943,15.2095 15.0318,14.454 15.3405,14.145 C15.632,13.8531 15.7864,13.8531 16.0951,13.9905 L18.4962,15.1923 C18.7877,15.3468 19.0965,15.4842 19.2508,15.6387 C19.4052,16.0851 19.4052,16.686 19.0965,17.1324 L19.0622,17.1324 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7422,5.85593 L21.9421,6.16616 C24.96,11.5632 23.3396,18.3681 18.1693,21.7369 C16.3234,22.8802 14.1792,23.4545 12.0304,23.4545 C10.049,23.4545 8.03522,22.8871 6.16985,21.8827 L5.74331,21.6035 L5.53926,21.47 L5.30366,21.533 L1.72136,22.4911 L2.67869,18.9041 L2.74145,18.669 L2.60836,18.4652 L2.31821,18.021 C2.31799,18.0206 2.31777,18.0203 2.31755,18.0199 C-1.09672,12.7364 0.601012,5.55858 5.88482,2.26502 C11.3121,-1.0324 18.3206,0.545899 21.7422,5.85593 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.09091
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialWaWhite);
export default __webpack_public_path__ + "static/media/social_wa_white.42ba7538.svg";
export { ForwardRef as ReactComponent };